import { resolveDownloadFilename } from 'utils/files'

import { isActionRelevant } from './utils'

/** Downloads an attachment from the Member Communication API */
export const downloadAttachment = () => next => action => {
  if (!isActionRelevant(action, /DOWNLOAD_ATTACHMENT_SUCCESS/))
    return next(action)

  const { payload, meta } = action
  const { filename, attachmentId } = meta
  const { blob, contentDisposition } = payload

  // Create a link element
  const link = document.createElement('a')
  const objectUrl = URL.createObjectURL(blob)
  link.href = objectUrl
  // Jira doesn't always give us a filename, and `link.download = null` saves
  // the file as `null` with no extension for the member to fail to open
  link.download = resolveDownloadFilename({
    contentDisposition,
    filename,
    attachmentId,
    mimeType: blob?.type,
  })

  // Append link to body
  document.body.appendChild(link)

  // Programmatically click the link to trigger download
  link.click()

  // Remove link from body
  document.body.removeChild(link)

  // Release the blob, or every download the member starts is held in memory
  // for the life of the page. Deferred so revoking can't cancel the download
  // we just started.
  setTimeout(() => URL.revokeObjectURL(objectUrl))

  return next(action)
}
